<div data-testid="third-party-o2o-page" class="p-4 flex-table-page">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "third_party.o2o.title" | translate }}
  </h2>
  <!-- Search Form -->
  <app-search-form
    data-testid="third-party-o2o-search-form"
    [orderSources]="platformStatusOptions()"
    [salesChannels]="salesChannels()"
    [buyerNotesOptions]="refundStatusOptions()"
    [giftOptions]="flowStatusOptions()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-status-filter
        [primaryButton]="primaryButton"
        [secondaryButton]="secondaryButton"
        (primaryButtonClick)="onCreateOrder()"
        (secondaryButtonClick)="onDownloadOrders()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Status Filter with Action Buttons -->
  <div class="mb-2 flex-table-header">
    <app-status-filter
      [statusOptions]="statusOptions"
      (statusChange)="onStatusChange($event)"
    ></app-status-filter>
  </div>

  <!-- Data Table -->
  <div class="flex-table-section">
    <app-data-table
      data-testid="third-party-o2o-table"
      [dataSource]="orders()"
      [columns]="tableColumns"
      [rows]="pageSize()"
      [first]="first()"
      [totalRecords]="totalRecords()"
      scrollHeight="flex"
      [loading]="loading()"
      [selection]="selectedOrders()"
      [hasCheckColumn]="true"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPageChange($event)"
    ></app-data-table>
  </div>

  <!-- Create Order Dialog -->
  <div
    data-testid="third-party-o2o-create-order-dialog"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    *ngIf="showCreateOrderDialog()"
  >
    <div class="bg-white rounded-lg p-6 w-96 max-w-md">
      <h3 class="text-lg font-semibold mb-4">
        {{ "third_party.o2o.dialog.create_order.title" | translate }}
      </h3>
      <div class="space-y-4">
        <p class="text-gray-600">
          {{ "third_party.o2o.dialog.create_order.message" | translate }}
        </p>
        <div class="form-field">
          <label
            for="order-details"
            class="form-label text-sm font-medium text-gray-700"
            >{{
              "third_party.o2o.dialog.create_order.order_details" | translate
            }}</label
          >
          <textarea
            data-testid="third-party-o2o-create-order-details-input"
            id="order-details"
            rows="4"
            class="w-full text-sm border border-gray-300 rounded-md px-3 py-2"
            [placeholder]="
              'third_party.o2o.dialog.create_order.placeholder' | translate
            "
          ></textarea>
        </div>
      </div>
      <div class="flex justify-end gap-2 mt-6">
        <button
          data-testid="third-party-o2o-create-order-cancel-btn"
          type="button"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          (click)="cancelCreateOrder()"
        >
          {{ "third_party.o2o.dialog.create_order.cancel" | translate }}
        </button>
        <button
          data-testid="third-party-o2o-create-order-confirm-btn"
          type="button"
          class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700"
          (click)="confirmCreateOrder()"
        >
          {{ "third_party.o2o.dialog.create_order.confirm" | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Download Orders Dialog -->
  <div
    data-testid="third-party-o2o-download-orders-dialog"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    *ngIf="showDownloadDialog()"
  >
    <div class="bg-white rounded-lg p-6 w-96 max-w-md">
      <h3 class="text-lg font-semibold mb-4">
        {{ "third_party.o2o.dialog.download_orders.title" | translate }}
      </h3>
      <div class="space-y-4">
        <p class="text-gray-600">
          {{ "third_party.o2o.dialog.download_orders.message" | translate }}
        </p>
        <div class="form-field">
          <label
            for="download-options"
            class="form-label text-sm font-medium text-gray-700"
            >{{
              "third_party.o2o.dialog.download_orders.download_options"
                | translate
            }}</label
          >
          <select
            data-testid="third-party-o2o-download-options-select"
            id="download-options"
            class="w-full text-sm border border-gray-300 rounded-md px-3 py-2"
          >
            <option value="">
              {{
                "third_party.o2o.dialog.download_orders.placeholder" | translate
              }}
            </option>
            <option value="all">
              {{
                "third_party.o2o.dialog.download_orders.all_orders" | translate
              }}
            </option>
            <option value="pending">
              {{
                "third_party.o2o.dialog.download_orders.pending_orders"
                  | translate
              }}
            </option>
            <option value="completed">
              {{
                "third_party.o2o.dialog.download_orders.completed_orders"
                  | translate
              }}
            </option>
          </select>
        </div>
      </div>
      <div class="flex justify-end gap-2 mt-6">
        <button
          data-testid="third-party-o2o-download-orders-cancel-btn"
          type="button"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          (click)="cancelDownloadOrders()"
        >
          {{ "third_party.o2o.dialog.download_orders.cancel" | translate }}
        </button>
        <button
          data-testid="third-party-o2o-download-orders-confirm-btn"
          type="button"
          class="px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md hover:bg-green-700"
          (click)="confirmDownloadOrders()"
        >
          {{ "third_party.o2o.dialog.download_orders.download" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
